export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categories: string[];
  description: string;
  shortDescription: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updateDate: string;
  chapters: ComicChapter[];
  tags: string[];
}

export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', count: 120 },
  { slug: 'korean', name: '韩漫', icon: 'ri-flag-line', count: 48 },
  { slug: 'japanese', name: '日漫', icon: 'ri-earth-line', count: 35 },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 28 },
  { slug: 'action', name: '热血', icon: 'ri-fire-line', count: 22 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 18 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 15 },
  { slug: 'horror', name: '悬疑', icon: 'ri-ghost-line', count: 12 },
  { slug: 'school', name: '校园', icon: 'ri-building-line', count: 10 },
  { slug: 'bl', name: 'BL', icon: 'ri-user-heart-line', count: 8 },
];

export const comics: ComicItem[] = [
  {
    id: 'comic-1',
    title: '霸道总裁的秘密恋人',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20illustration%2C%20elegant%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20clean%20drawing%20style%2C%20manga%20artwork%20with%20delicate%20linework%2C%20professional%20man%20and%20woman%20facing%20each%20other%2C%20pastel%20warm%20color%20palette%2C%20romantic%20atmosphere%2C%20contemporary%20Korean%20webtoon%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'korean',
    categories: ['korean', 'romance'],
    description: '普通上班族林小雨意外成为霸道总裁的私人秘书，两个截然不同的世界碰撞出意想不到的火花。在公司权力斗争的漩涡中，他们的感情面临重重考验。这是一部充满戏剧性反转的都市爱情韩漫，画风精致细腻，情感描写深入人心。',
    shortDescription: '普通上班族林小雨意外成为霸道总裁的私人秘书，两个截然不同的世界碰撞出意想不到的火花...',
    status: '连载中',
    rating: 4.8,
    views: 1258000,
    favorites: 89200,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `ch-comic-1-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['霸道总裁', '办公室恋情', '甜宠', '都市', '逆袭'],
  },
  {
    id: 'comic-2',
    title: '剑与魔法的传说',
    author: '朴正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20fantasy%20adventure%20cover%2C%20young%20warrior%20holding%20glowing%20sword%20in%20magical%20forest%2C%20epic%20fantasy%20illustration%2C%20warm%20amber%20and%20gold%20lighting%2C%20detailed%20character%20design%2C%20mystical%20creatures%20in%20background%2C%20vibrant%20clean%20anime%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    categories: ['japanese', 'action', 'fantasy'],
    description: '在魔法与剑并存的世界中，少年剑士艾伦踏上寻找传说之剑的冒险旅程。途中结识了各具特色的伙伴，共同对抗黑暗势力的侵袭。宏大的世界观设定，精彩的战斗场面，让人欲罢不能的热血奇幻大作。',
    shortDescription: '少年剑士艾伦踏上寻找传说之剑的冒险旅程，途结识伙伴，共同对抗黑暗势力...',
    status: '连载中',
    rating: 4.9,
    views: 2150000,
    favorites: 156300,
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 124 }, (_, i) => ({
      id: `ch-comic-2-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['冒险', '魔法', '热血', '友情', '成长'],
  },
  {
    id: 'comic-3',
    title: '甜蜜的陷阱',
    author: '李美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%2C%20beautiful%20couple%20in%20cherry%20blossom%20park%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20peach%20color%20tones%2C%20romantic%20illustration%2C%20clean%20digital%20manga%20style%2C%20gentle%20lighting%2C%20emotional%20expression&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'romance',
    categories: ['korean', 'romance', 'comedy'],
    description: '相亲对象竟然是高中时的死对头！两个冤家被迫相处，在啼笑皆非的日常中，昔日的恩怨逐渐化为甜蜜的情愫。轻松搞笑的恋爱喜剧，每一话都让人忍不住嘴角上扬。',
    shortDescription: '相亲对象竟然是高中时的死对头！两个冤家被迫相处，恩怨逐渐化为甜蜜的情愫...',
    status: '已完结',
    rating: 4.7,
    views: 980000,
    favorites: 67200,
    updateDate: '2026-07-15',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-comic-3-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2025-${String(7 + Math.floor(i / 8)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['恋爱喜剧', '冤家', '甜宠', '校园回忆', '先婚后爱'],
  },
  {
    id: 'comic-4',
    title: '暗影猎手',
    author: '郑允浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20urban%20fantasy%20manga%20cover%2C%20mysterious%20hooded%20hunter%20in%20rainy%20city%20alley%2C%20noir%20atmosphere%20with%20dramatic%20lighting%2C%20supernatural%20thriller%20artwork%2C%20shadowy%20figure%20with%20weapon%2C%20dark%20warm%20tones%2C%20intense%20mood%2C%20detailed%20Korean%20manhwa%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'horror',
    categories: ['korean', 'action', 'horror'],
    description: '在充满超自然生物的首尔地下世界，猎人组织暗中守护着人类的安宁。主角姜浩是一名特殊的暗影猎手，拥有看穿怪物伪装的能力。紧张刺激的战斗场面，环环相扣的悬疑剧情，带你进入不可知的黑暗世界。',
    shortDescription: '在充满超自然生物的首尔地下世界，猎人组织暗中守护着人类的安宁...',
    status: '连载中',
    rating: 4.6,
    views: 1860000,
    favorites: 124500,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: `ch-comic-4-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['都市奇幻', '猎魔', '悬疑', '超能力', '战斗'],
  },
  {
    id: 'comic-5',
    title: '我的同桌是校花',
    author: '张小雨',
    coverImage: 'https://readdy.ai/api/search-image?query=School%20romance%20manga%20cover%2C%20high%20school%20students%20sitting%20at%20desk%20in%20classroom%2C%20sunlight%20streaming%20through%20window%2C%20youth%20romantic%20comedy%20illustration%2C%20bright%20warm%20color%20palette%2C%20clean%20anime%20art%20style%2C%20Japanese%20manga%20aesthetic&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'school',
    categories: ['japanese', 'school', 'romance', 'comedy'],
    description: '平凡高中生王小明的新同桌竟然是全校公认的校花。从尴尬的日常相处到渐渐产生好感，青春校园的甜蜜故事就此展开。纯真美好的高中生活，让人回忆起那段最美好的时光。',
    shortDescription: '平凡高中生王小明的新同桌竟然是全校公认的校花，青春校园的甜蜜故事就此展开...',
    status: '连载中',
    rating: 4.5,
    views: 870000,
    favorites: 58900,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `ch-comic-5-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['校园', '青春', '恋爱', '日常', '治愈'],
  },
  {
    id: 'comic-6',
    title: '重生之商业帝国',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Business%20drama%20manhwa%20cover%2C%20confident%20businessman%20in%20luxury%20office%20overlooking%20city%20skyline%2C%20power%20and%20ambition%20theme%2C%20sleek%20modern%20illustration%2C%20warm%20golden%20hour%20lighting%2C%20Korean%20webtoon%20style%2C%20professional%20atmosphere&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'korean',
    categories: ['korean', 'action'],
    description: '商业天才意外重生回到二十年前，凭借前世的记忆和商业洞察力，一步步建立属于自己的商业帝国。商场如战场，看主角如何运筹帷幄，在激烈的商战中杀出重围。',
    shortDescription: '商业天才意外重生回到二十年前，凭借前世记忆，一步步建立属于自己的商业帝国...',
    status: '连载中',
    rating: 4.8,
    views: 1650000,
    favorites: 109800,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: `ch-comic-6-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['重生', '商战', '逆袭', '爽文', '都市'],
  },
  {
    id: 'comic-7',
    title: '异世界美食之旅',
    author: '田中花子',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20cooking%20manga%20cover%2C%20cheerful%20chef%20in%20fantasy%20world%20market%20with%20magical%20ingredients%2C%20colorful%20warm%20illustration%2C%20food%20and%20adventure%20theme%2C%20clean%20anime%20art%20style%2C%20cozy%20vibrant%20atmosphere&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'fantasy',
    categories: ['japanese', 'fantasy', 'comedy'],
    description: '日本料理人穿越到剑与魔法的异世界，用现代烹饪技巧征服异世界居民的味蕾。从路边小摊到王国御厨，看主角如何用美食改变异世界的饮食文化。搞笑又温心的美食冒险故事。',
    shortDescription: '日本料理人穿越到异世界，用现代烹饪技巧征服异世界居民的味蕾...',
    status: '连载中',
    rating: 4.7,
    views: 1120000,
    favorites: 78200,
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `ch-comic-7-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['异世界', '美食', '冒险', '搞笑', '治愈'],
  },
  {
    id: 'comic-8',
    title: '无间深渊',
    author: '崔胜贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20manhwa%20cover%2C%20intense%20close-up%20of%20character%20with%20mysterious%20expression%2C%20dark%20dramatic%20lighting%2C%20suspense%20mystery%20illustration%2C%20Korean%20noir%20webtoon%20style%2C%20warm%20shadow%20tones%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'horror',
    categories: ['korean', 'horror'],
    description: '记者韩素英在调查一桩离奇失踪案时，意外卷入了一个隐藏在城市深处的秘密组织。随着调查深入，真相越来越令人毛骨悚然。高智商悬疑大作，每一话都让人屏息以待。',
    shortDescription: '记者韩素英在调查离奇失踪案时，意外卷入隐藏在城市深处的秘密组织...',
    status: '连载中',
    rating: 4.9,
    views: 1530000,
    favorites: 98700,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-comic-8-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(4 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['悬疑', '犯罪', '推理', '都市', '惊悚'],
  },
  {
    id: 'comic-9',
    title: '花与秘密',
    author: '尹素婉',
    coverImage: 'https://readdy.ai/api/search-image?query=BL%20boys%20love%20manga%20cover%2C%20two%20young%20men%20in%20flower%20garden%20setting%2C%20gentle%20romantic%20atmosphere%2C%20soft%20pastel%20warm%20colors%2C%20delicate%20illustration%20style%2C%20emotional%20Korean%20manhwa%20aesthetic%2C%20beautiful%20character%20design&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'bl',
    categories: ['korean', 'bl', 'romance'],
    description: '花店老板与神秘顾客之间的温暖故事。每一束花都承载着一段心事，每一次相遇都是命中注定。细腻的情感描写，唯美的画风，让人沉浸在这段温柔的爱情故事中。',
    shortDescription: '花店老板与神秘顾客之间的温暖故事，每一束花都承载着一段心事...',
    status: '已完结',
    rating: 4.6,
    views: 720000,
    favorites: 45600,
    updateDate: '2026-06-20',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-comic-9-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2025-${String(6 + Math.floor(i / 8)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['BL', '花店', '温柔', '治愈', '都市'],
  },
  {
    id: 'comic-10',
    title: '最强武道宗师',
    author: '李宗赫',
    coverImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20action%20manhwa%20cover%2C%20powerful%20fighter%20in%20dynamic%20battle%20pose%2C%20energy%20effects%20surrounding%2C%20intense%20action%20illustration%2C%20warm%20orange%20and%20red%20tones%2C%20Korean%20webtoon%20style%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'action',
    categories: ['korean', 'action'],
    description: '被废武功的武道宗师重新修炼，从零开始踏上巅峰之路。精彩绝伦的武术对决，热血沸腾的战斗场面，展现武道精神的极致魅力。动作场面酣畅淋漓，让人热血沸腾。',
    shortDescription: '被废武功的武道宗师重新修炼，从零开始踏上巅峰之路...',
    status: '连载中',
    rating: 4.8,
    views: 1980000,
    favorites: 143200,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 110 }, (_, i) => ({
      id: `ch-comic-10-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['武道', '热血', '逆袭', '战斗', '成长'],
  },
  {
    id: 'comic-11',
    title: '星空下的约定',
    author: '山田花',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20romance%20manga%20cover%2C%20couple%20under%20starry%20night%20sky%20on%20hilltop%2C%20nostalgic%20warm%20atmosphere%2C%20summer%20evening%20illustration%2C%20clean%20anime%20style%2C%20soft%20gentle%20lighting%2C%20emotional%20youth%20romance&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'romance',
    categories: ['japanese', 'romance', 'school'],
    description: '天文社的两个高中生在观测星空时相识，在璀璨星光下许下彼此的约定。纯爱故事，画风唯美，充满青春的悸动与美好。星空为证，这是一段不容错过的浪漫故事。',
    shortDescription: '天文社的两个高中生在观测星空时相识，在璀璨星光下许下彼此的约定...',
    status: '已完结',
    rating: 4.7,
    views: 650000,
    favorites: 43200,
    updateDate: '2026-05-30',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `ch-comic-11-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2025-${String(3 + Math.floor(i / 8)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['纯爱', '天文', '校园', '青春', '约定'],
  },
  {
    id: 'comic-12',
    title: '搞笑一家人',
    author: '赵明洙',
    coverImage: 'https://readdy.ai/api/search-image?query=Family%20comedy%20manga%20cover%2C%20quirky%20family%20members%20posing%20together%2C%20funny%20expressions%2C%20bright%20cheerful%20colors%2C%20warm%20Korean%20webtoon%20style%2C%20lighthearted%20illustration%2C%20cozy%20home%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'comedy',
    categories: ['korean', 'comedy'],
    description: '一个普通又不普通的四口之家的爆笑日常。严厉的爸爸、唠叨的妈妈、调皮的弟弟和吐槽担当的姐姐，每一天都充满了欢乐与温暖。轻松搞笑的家庭喜剧，让你笑出腹肌。',
    shortDescription: '一个普通又不普通的四口之家的爆笑日常，每一天都充满了欢乐与温暖...',
    status: '连载中',
    rating: 4.5,
    views: 920000,
    favorites: 61200,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `ch-comic-12-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-${String(1 + Math.floor(i / 4)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['家庭', '搞笑', '日常', '温馨', '四格'],
  },
];

export const testimonials = [
  {
    id: 'test-1',
    name: '漫画爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20person%20avatar%20portrait%2C%20friendly%20smile%2C%20simple%20clean%20background%2C%20warm%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '奇妙漫画网真的是我遇到的最好的免费漫画阅读平台！韩漫资源特别齐全，更新速度也很快，画质清晰，阅读体验流畅，强烈推荐给所有漫画爱好者。',
    date: '2026-07-28',
  },
  {
    id: 'test-2',
    name: '资深漫迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20avatar%2C%20warm%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '找了好久终于找到一个分类这么齐全的漫画网站！日漫韩漫都有，而且每个分类下面都好作品不断。每天必刷的网站，已经推荐给身边所有朋友了。',
    date: '2026-07-25',
  },
  {
    id: 'test-3',
    name: '二次元达人小张',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20man%20portrait%2C%20casual%20friendly%20look%2C%20simple%20clean%20background%2C%20warm%20natural%20lighting%2C%20headshot%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '网站界面设计很好看，用起来很舒服。最重要的是更新快、画质好，很多热门韩漫都是同步更新的。客服反馈也很及时，真心推荐。',
    date: '2026-07-22',
  },
  {
    id: 'test-4',
    name: '追漫小仙女',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20smiling%20portrait%2C%20warm%20and%20friendly%2C%20simple%20neutral%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '从学生时代就开始在这儿看漫画了，见证了奇妙漫画网的成长。现在资源越来越丰富，分类也更细了。希望越做越好，会一直支持下去！',
    date: '2026-07-18',
  },
];

export const faqData = [
  {
    question: '奇妙漫画网的漫画是免费的吗？',
    answer: '是的，奇妙漫画网上的所有漫画内容都是完全免费的。我们致力于为广大漫画爱好者提供优质的免费漫画阅读服务，无需付费即可畅享海量漫画资源。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '热门连载漫画通常每周更新1-2话，具体更新频率取决于原作发布节奏。我们会在第一时间同步更新，确保读者能够及时看到最新章节。网站首页会显示最近更新的漫画列表。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '奇妙漫画网支持PC端、平板和手机端浏览阅读。我们的网站采用响应式设计，无论在电脑、iPad还是手机上，都能获得流畅舒适的阅读体验。',
  },
  {
    question: '如何找到想看的漫画？',
    answer: '您可以通过以下几种方式找到心仪的漫画：1）在首页搜索框直接搜索漫画名称；2）通过分类页面按类型筛选；3）浏览首页的热门推荐和最新更新栏目；4）查看每个漫画详情页的关联推荐。',
  },
  {
    question: '漫画画质怎么样？',
    answer: '我们提供的漫画均为高清画质，确保读者能够清楚地看到每一处细节。图片经过专业优化处理，在保证画质的同时也兼顾了加载速度。',
  },
  {
    question: '需要注册账号吗？',
    answer: '目前浏览漫画不需要注册账号，您可以直接访问网站免费阅读所有内容。我们注重用户体验，尽量减少不必要的门槛。',
  },
];